module.exports = __webpack_public_path__ + "static/media/general-img-activityEnds@2x.142fb95d.png";